/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './request';
import './custom_report';
import '../models/users';
import '../../../common/currency';
import '../../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "reporting": {
                    "nested": {
                      "EmployeeSalesSummaryRequest": {
                        "fields": {
                          "requestParams": {
                            "type": "squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "requestFlags": {
                            "type": "squareup.beemo.api.v2.reporting.CustomReportRequestFlags",
                            "id": 2,
                            "rule": "optional"
                          },
                          "aggregateOptions": {
                            "type": "squareup.beemo.api.v2.reporting.CustomReportAggregateOptions",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "EmployeeSalesSummary": {
                        "fields": {
                          "employee": {
                            "type": "squareup.beemo.api.v2.models.Employee",
                            "id": 1,
                            "rule": "optional"
                          },
                          "transactionCount": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          },
                          "totalCollectedMoney": {
                            "type": "squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "tipMoney": {
                            "type": "squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "autoGratuityMoney": {
                            "type": "squareup.common.Money",
                            "id": 9,
                            "rule": "optional"
                          },
                          "netSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "hoursWorked": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "netSalesPerHourMoney": {
                            "type": "squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "netSalesPerTransactionMoney": {
                            "type": "squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "coverCount": {
                            "type": "int64",
                            "id": 10,
                            "rule": "optional"
                          },
                          "commissionMoney": {
                            "type": "squareup.common.Money",
                            "id": 11,
                            "rule": "optional"
                          },
                          "itemCommissionMoney": {
                            "type": "squareup.common.Money",
                            "id": 13,
                            "rule": "optional"
                          },
                          "serviceCommissionMoney": {
                            "type": "squareup.common.Money",
                            "id": 14,
                            "rule": "optional"
                          },
                          "deductedServiceCostMoney": {
                            "type": "squareup.common.Money",
                            "id": 15,
                            "rule": "optional"
                          },
                          "grossSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 12,
                            "rule": "optional"
                          }
                        }
                      },
                      "EmployeeSalesSummaryResponse": {
                        "fields": {
                          "employeeSalesSummary": {
                            "type": "squareup.beemo.api.v2.reporting.EmployeeSalesSummary",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "totalTransactionCount": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          },
                          "totalCollectedMoney": {
                            "type": "squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "nonEmployeeTransactionCount": {
                            "type": "int64",
                            "id": 4,
                            "rule": "optional"
                          },
                          "nonEmployeeCollectedMoney": {
                            "type": "squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "nonEmployeeTipMoney": {
                            "type": "squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "totalCommissionMoney": {
                            "type": "squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "totalTipMoney": {
                            "type": "squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "totalGrossSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 9,
                            "rule": "optional"
                          },
                          "nonEmployeeGrossSalesMoney": {
                            "type": "squareup.common.Money",
                            "id": 10,
                            "rule": "optional"
                          },
                          "totalItemCommissionMoney": {
                            "type": "squareup.common.Money",
                            "id": 11,
                            "rule": "optional"
                          },
                          "totalServiceCommissionMoney": {
                            "type": "squareup.common.Money",
                            "id": 12,
                            "rule": "optional"
                          },
                          "totalDeductedServiceCostMoney": {
                            "type": "squareup.common.Money",
                            "id": 13,
                            "rule": "optional"
                          }
                        }
                      },
                      "GiftCardSummaryRequest": {
                        "fields": {
                          "requestParams": {
                            "type": "squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "GiftCardSummaryResponse": {
                        "fields": {
                          "newCardsSummary": {
                            "type": "squareup.beemo.api.v2.reporting.GiftCardSummary",
                            "id": 1,
                            "rule": "optional"
                          },
                          "existingCardsSummary": {
                            "type": "squareup.beemo.api.v2.reporting.GiftCardSummary",
                            "id": 2,
                            "rule": "optional"
                          },
                          "totalCardsSummary": {
                            "type": "squareup.beemo.api.v2.reporting.GiftCardSummary",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "GiftCardSummary": {
                        "fields": {
                          "loadedCardCount": {
                            "type": "int64",
                            "id": 1,
                            "rule": "optional"
                          },
                          "redeemedCardCount": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          },
                          "loadEventCount": {
                            "type": "int64",
                            "id": 3,
                            "rule": "optional"
                          },
                          "totalLoadedMoney": {
                            "type": "squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "totalRedeemedMoney": {
                            "type": "squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "OutstandingGiftCardReportRequest": {
                        "fields": {
                          "requestParams": {
                            "type": "squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "OutstandingGiftCard": {
                        "fields": {
                          "giftCardToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "panSuffix": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "issueTime": {
                            "type": "squareup.common.time.DateTime",
                            "id": 3,
                            "rule": "optional"
                          },
                          "lastReloadTime": {
                            "type": "squareup.common.time.DateTime",
                            "id": 4,
                            "rule": "optional"
                          },
                          "lastUsedTime": {
                            "type": "squareup.common.time.DateTime",
                            "id": 5,
                            "rule": "optional"
                          },
                          "outstandingMoney": {
                            "type": "squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "subunitMerchant": {
                            "type": "squareup.beemo.api.v2.models.Merchant",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      },
                      "OutstandingGiftCardReportResponse": {
                        "fields": {
                          "giftCard": {
                            "type": "squareup.beemo.api.v2.reporting.OutstandingGiftCard",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "LaborVsSalesSummaryRequest": {
                        "fields": {
                          "requestParams": {
                            "type": "squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "groupByType": {
                            "type": "squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "filter": {
                            "type": "squareup.beemo.api.v2.reporting.Filter",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "requestFlags": {
                            "type": "squareup.beemo.api.v2.reporting.CustomReportRequestFlags",
                            "id": 4,
                            "rule": "optional"
                          },
                          "aggregateOptions": {
                            "type": "squareup.beemo.api.v2.reporting.CustomReportAggregateOptions",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "LaborVsSalesSummaryResponse": {
                        "fields": {
                          "customReport": {
                            "type": "squareup.beemo.api.v2.reporting.LaborVsSalesReport",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "LaborVsSalesReport": {
                        "fields": {
                          "groupByType": {
                            "type": "squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "groupByValue": {
                            "type": "squareup.beemo.api.v2.reporting.GroupByValue",
                            "id": 2,
                            "rule": "optional"
                          },
                          "aggregate": {
                            "type": "squareup.beemo.api.v2.reporting.LaborVsSalesAggregate",
                            "id": 3,
                            "rule": "optional"
                          },
                          "subReport": {
                            "type": "squareup.beemo.api.v2.reporting.LaborVsSalesReport",
                            "id": 4,
                            "rule": "repeated"
                          }
                        }
                      },
                      "LaborVsSalesAggregate": {
                        "fields": {
                          "net": {
                            "type": "squareup.beemo.api.v2.reporting.LaborVsSalesAggregate.SalesDetails",
                            "id": 1,
                            "rule": "optional"
                          },
                          "labor": {
                            "type": "squareup.beemo.api.v2.reporting.LaborVsSalesAggregate.LaborDetails",
                            "id": 2,
                            "rule": "optional"
                          },
                          "laborPercentage": {
                            "type": "squareup.beemo.api.v2.reporting.LaborVsSalesAggregate.LaborPercentage",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "SalesDetails": {
                            "fields": {
                              "netSalesMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "LaborDetails": {
                            "fields": {
                              "totalLaborMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "regularLaborMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "overtimeLaborMoney": {
                                "type": "squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              },
                              "doubleTimeLaborMoney": {
                                "type": "squareup.common.Money",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          },
                          "LaborPercentage": {
                            "fields": {
                              "type": {
                                "type": "squareup.beemo.api.v2.reporting.LaborVsSalesAggregate.LaborPercentage.Type",
                                "id": 1,
                                "rule": "optional"
                              },
                              "percentage": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Type": {
                                "values": {
                                  "NA": 1,
                                  "PERCENTAGE": 2
                                }
                              }
                            }
                          }
                        }
                      },
                      "SectionSalesReportRequest": {
                        "fields": {
                          "requestParams": {
                            "type": "squareup.beemo.api.v2.reporting.RequestParams",
                            "id": 1,
                            "rule": "optional"
                          },
                          "groupByType": {
                            "type": "squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "filter": {
                            "type": "squareup.beemo.api.v2.reporting.Filter",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "requestFlags": {
                            "type": "squareup.beemo.api.v2.reporting.CustomReportRequestFlags",
                            "id": 4,
                            "rule": "optional"
                          },
                          "aggregateOptions": {
                            "type": "squareup.beemo.api.v2.reporting.CustomReportAggregateOptions",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "SectionSalesReportResponse": {
                        "fields": {
                          "customReport": {
                            "type": "squareup.beemo.api.v2.reporting.SectionSalesReport",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "SectionSalesAggregate": {
                        "fields": {
                          "sales": {
                            "type": "squareup.beemo.api.v2.reporting.SectionSalesAggregate.Details",
                            "id": 1,
                            "rule": "optional"
                          },
                          "refunds": {
                            "type": "squareup.beemo.api.v2.reporting.SectionSalesAggregate.Details",
                            "id": 2,
                            "rule": "optional"
                          },
                          "net": {
                            "type": "squareup.beemo.api.v2.reporting.SectionSalesAggregate.Details",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Details": {
                            "fields": {
                              "totalCollectedMoney": {
                                "type": "squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "tipMoney": {
                                "type": "squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "grossSalesMoney": {
                                "type": "squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              },
                              "productSalesMoney": {
                                "type": "squareup.common.Money",
                                "id": 4,
                                "rule": "optional"
                              },
                              "discountMoney": {
                                "type": "squareup.common.Money",
                                "id": 5,
                                "rule": "optional"
                              },
                              "netSalesMoney": {
                                "type": "squareup.common.Money",
                                "id": 6,
                                "rule": "optional"
                              },
                              "coverCount": {
                                "type": "int64",
                                "id": 7,
                                "rule": "optional"
                              },
                              "grossSalesMoneyFromCovers": {
                                "type": "squareup.common.Money",
                                "id": 8,
                                "rule": "optional"
                              },
                              "averageGrossSalesMoneyPerCover": {
                                "type": "squareup.common.Money",
                                "id": 9,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "SectionSalesReport": {
                        "fields": {
                          "groupByType": {
                            "type": "squareup.beemo.api.v2.reporting.GroupByType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "groupByValue": {
                            "type": "squareup.beemo.api.v2.reporting.GroupByValue",
                            "id": 2,
                            "rule": "optional"
                          },
                          "aggregate": {
                            "type": "squareup.beemo.api.v2.reporting.SectionSalesAggregate",
                            "id": 3,
                            "rule": "optional"
                          },
                          "subReport": {
                            "type": "squareup.beemo.api.v2.reporting.SectionSalesReport",
                            "id": 4,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.EmployeeSalesSummaryRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.EmployeeSalesSummary && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.EmployeeSalesSummaryResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GiftCardSummaryRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GiftCardSummaryResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GiftCardSummary && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.OutstandingGiftCardReportRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.OutstandingGiftCard && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.OutstandingGiftCardReportResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.LaborVsSalesSummaryRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.LaborVsSalesSummaryResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.LaborVsSalesReport && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.LaborVsSalesAggregate && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.LaborVsSalesAggregate?.nested?.SalesDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.LaborVsSalesAggregate?.nested?.LaborDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.LaborVsSalesAggregate?.nested?.LaborPercentage && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.LaborVsSalesAggregate?.nested?.LaborPercentage?.nested?.Type && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SectionSalesReportRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SectionSalesReportResponse && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SectionSalesAggregate && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SectionSalesAggregate?.nested?.Details && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.SectionSalesReport) {
  $root.addJSON(jsonData);
}

/**
 * The request message for returning employee sales summary information.
 *
 * SOURCE EmployeeSalesSummaryRequest @ squareup/beemo/v2/reporting/summary.proto at 15:1
 */
export const EmployeeSalesSummaryRequest = $root.lookupType('squareup.beemo.api.v2.reporting.EmployeeSalesSummaryRequest');
fixType(EmployeeSalesSummaryRequest);
Builder.createAndAttachToType(EmployeeSalesSummaryRequest);
/**
 * The message containing the sales summary for an employee.
 *
 * SOURCE EmployeeSalesSummary @ squareup/beemo/v2/reporting/summary.proto at 23:1
 */
export const EmployeeSalesSummary = $root.lookupType('squareup.beemo.api.v2.reporting.EmployeeSalesSummary');
fixType(EmployeeSalesSummary);
Builder.createAndAttachToType(EmployeeSalesSummary);
/**
 * The response message for returning employee sales information.
 *
 * SOURCE EmployeeSalesSummaryResponse @ squareup/beemo/v2/reporting/summary.proto at 78:1
 */
export const EmployeeSalesSummaryResponse = $root.lookupType('squareup.beemo.api.v2.reporting.EmployeeSalesSummaryResponse');
fixType(EmployeeSalesSummaryResponse);
Builder.createAndAttachToType(EmployeeSalesSummaryResponse);
/**
 * SOURCE GiftCardSummaryRequest @ squareup/beemo/v2/reporting/summary.proto at 95:1
 */
export const GiftCardSummaryRequest = $root.lookupType('squareup.beemo.api.v2.reporting.GiftCardSummaryRequest');
fixType(GiftCardSummaryRequest);
Builder.createAndAttachToType(GiftCardSummaryRequest);
/**
 * SOURCE GiftCardSummaryResponse @ squareup/beemo/v2/reporting/summary.proto at 99:1
 */
export const GiftCardSummaryResponse = $root.lookupType('squareup.beemo.api.v2.reporting.GiftCardSummaryResponse');
fixType(GiftCardSummaryResponse);
Builder.createAndAttachToType(GiftCardSummaryResponse);
/**
 * SOURCE GiftCardSummary @ squareup/beemo/v2/reporting/summary.proto at 108:1
 */
export const GiftCardSummary = $root.lookupType('squareup.beemo.api.v2.reporting.GiftCardSummary');
fixType(GiftCardSummary);
Builder.createAndAttachToType(GiftCardSummary);
/**
 * SOURCE OutstandingGiftCardReportRequest @ squareup/beemo/v2/reporting/summary.proto at 125:1
 */
export const OutstandingGiftCardReportRequest = $root.lookupType('squareup.beemo.api.v2.reporting.OutstandingGiftCardReportRequest');
fixType(OutstandingGiftCardReportRequest);
Builder.createAndAttachToType(OutstandingGiftCardReportRequest);
/**
 * SOURCE OutstandingGiftCard @ squareup/beemo/v2/reporting/summary.proto at 130:1
 */
export const OutstandingGiftCard = $root.lookupType('squareup.beemo.api.v2.reporting.OutstandingGiftCard');
fixType(OutstandingGiftCard);
Builder.createAndAttachToType(OutstandingGiftCard);
/**
 * SOURCE OutstandingGiftCardReportResponse @ squareup/beemo/v2/reporting/summary.proto at 150:1
 */
export const OutstandingGiftCardReportResponse = $root.lookupType('squareup.beemo.api.v2.reporting.OutstandingGiftCardReportResponse');
fixType(OutstandingGiftCardReportResponse);
Builder.createAndAttachToType(OutstandingGiftCardReportResponse);
/**
 * The request message for returning labor vs. sales summary information.
 *
 * SOURCE LaborVsSalesSummaryRequest @ squareup/beemo/v2/reporting/summary.proto at 155:1
 */
export const LaborVsSalesSummaryRequest = $root.lookupType('squareup.beemo.api.v2.reporting.LaborVsSalesSummaryRequest');
fixType(LaborVsSalesSummaryRequest);
Builder.createAndAttachToType(LaborVsSalesSummaryRequest);
/**
 * The response message for returning labor vs. sales summary information.
 *
 * SOURCE LaborVsSalesSummaryResponse @ squareup/beemo/v2/reporting/summary.proto at 175:1
 */
export const LaborVsSalesSummaryResponse = $root.lookupType('squareup.beemo.api.v2.reporting.LaborVsSalesSummaryResponse');
fixType(LaborVsSalesSummaryResponse);
Builder.createAndAttachToType(LaborVsSalesSummaryResponse);
/**
 * SOURCE LaborVsSalesReport @ squareup/beemo/v2/reporting/summary.proto at 179:1
 */
export const LaborVsSalesReport = $root.lookupType('squareup.beemo.api.v2.reporting.LaborVsSalesReport');
fixType(LaborVsSalesReport);
Builder.createAndAttachToType(LaborVsSalesReport);
/**
 * SOURCE LaborVsSalesAggregate @ squareup/beemo/v2/reporting/summary.proto at 192:1
 */
export const LaborVsSalesAggregate = $root.lookupType('squareup.beemo.api.v2.reporting.LaborVsSalesAggregate');
fixType(LaborVsSalesAggregate);
Builder.createAndAttachToType(LaborVsSalesAggregate);
/**
 * SOURCE SalesDetails @ squareup/beemo/v2/reporting/summary.proto at 193:3
 */
LaborVsSalesAggregate.SalesDetails = $root.lookupType('squareup.beemo.api.v2.reporting.LaborVsSalesAggregate.SalesDetails');
fixType(LaborVsSalesAggregate.SalesDetails);
Builder.createAndAttachToType(LaborVsSalesAggregate.SalesDetails);
/**
 * SOURCE LaborDetails @ squareup/beemo/v2/reporting/summary.proto at 197:3
 */
LaborVsSalesAggregate.LaborDetails = $root.lookupType('squareup.beemo.api.v2.reporting.LaborVsSalesAggregate.LaborDetails');
fixType(LaborVsSalesAggregate.LaborDetails);
Builder.createAndAttachToType(LaborVsSalesAggregate.LaborDetails);
/**
 * SOURCE LaborPercentage @ squareup/beemo/v2/reporting/summary.proto at 207:3
 */
LaborVsSalesAggregate.LaborPercentage = $root.lookupType('squareup.beemo.api.v2.reporting.LaborVsSalesAggregate.LaborPercentage');
fixType(LaborVsSalesAggregate.LaborPercentage);
Builder.createAndAttachToType(LaborVsSalesAggregate.LaborPercentage);
/**
 * SOURCE Type @ squareup/beemo/v2/reporting/summary.proto at 208:5
 */
LaborVsSalesAggregate.LaborPercentage.Type = $root.lookupEnum('squareup.beemo.api.v2.reporting.LaborVsSalesAggregate.LaborPercentage.Type').values;
/**
 * The request message for returning section sales information.
 *
 * SOURCE SectionSalesReportRequest @ squareup/beemo/v2/reporting/summary.proto at 227:1
 */
export const SectionSalesReportRequest = $root.lookupType('squareup.beemo.api.v2.reporting.SectionSalesReportRequest');
fixType(SectionSalesReportRequest);
Builder.createAndAttachToType(SectionSalesReportRequest);
/**
 * The response message for returning section sales information.
 *
 * SOURCE SectionSalesReportResponse @ squareup/beemo/v2/reporting/summary.proto at 248:1
 */
export const SectionSalesReportResponse = $root.lookupType('squareup.beemo.api.v2.reporting.SectionSalesReportResponse');
fixType(SectionSalesReportResponse);
Builder.createAndAttachToType(SectionSalesReportResponse);
/**
 * SOURCE SectionSalesAggregate @ squareup/beemo/v2/reporting/summary.proto at 252:1
 */
export const SectionSalesAggregate = $root.lookupType('squareup.beemo.api.v2.reporting.SectionSalesAggregate');
fixType(SectionSalesAggregate);
Builder.createAndAttachToType(SectionSalesAggregate);
/**
 * SOURCE Details @ squareup/beemo/v2/reporting/summary.proto at 253:3
 */
SectionSalesAggregate.Details = $root.lookupType('squareup.beemo.api.v2.reporting.SectionSalesAggregate.Details');
fixType(SectionSalesAggregate.Details);
Builder.createAndAttachToType(SectionSalesAggregate.Details);
/**
 * SOURCE SectionSalesReport @ squareup/beemo/v2/reporting/summary.proto at 302:1
 */
export const SectionSalesReport = $root.lookupType('squareup.beemo.api.v2.reporting.SectionSalesReport');
fixType(SectionSalesReport);
Builder.createAndAttachToType(SectionSalesReport);